import { render, staticRenderFns } from "./RetailerChainSelection.vue?vue&type=template&id=2830bd0a&"
import script from "./RetailerChainSelection.vue?vue&type=script&lang=js&"
export * from "./RetailerChainSelection.vue?vue&type=script&lang=js&"
import style0 from "./RetailerChainSelection.vue?vue&type=style&index=0&id=2830bd0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports